import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import VisitorSetup from "SchoolSetup/routes/VisitorSetup";
import CasExternalSupervisorSetup from "SchoolSetup/routes/CasExternalSupervisorSetup";

export default store => ({
  path: "external-staff",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "grade-levels" */ "./components/ExternalStaff"
      ),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [VisitorSetup(store), CasExternalSupervisorSetup(store)],
});
